import { logger } from '@ecosystem/newron-client-lib';
import { trackAnalyticsEvent } from './track';
import { AnalyticsEvent, PlatformTrackingFunction } from './types';

const queue: AnalyticsEvent[] = [];
let isRunning = false;

const getNext = (): AnalyticsEvent | undefined => {
  return queue[0];
};

const removeFromQueue = (event: AnalyticsEvent) => {
  const index = queue.indexOf(event);
  if (index > -1) {
    queue.splice(index, 1);
  }
};

const trigger = async (platformTrackingFn: PlatformTrackingFunction) => {
  if (isRunning) {
    return;
  }
  isRunning = true;
  let next = getNext();
  while (next) {
    try {
      await trackAnalyticsEvent(next, platformTrackingFn);
    } catch (e) {
      logger.error(e, { message: '[analytics] tracking failed', eventName: next.eventName });
    }
    removeFromQueue(next);
    next = getNext();
  }
  isRunning = false;
};

export const add = (event: AnalyticsEvent, platformTrackingFn: PlatformTrackingFunction) => {
  queue.push(event);
  trigger(platformTrackingFn);
};
